"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getSectionUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
  divelement?: FieldConfig;
};

export const VerticalStoryImageCategoryNews = ({
  title = { hidden: false, value: "மகளிர் மணி", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  imageMetadata,
  divelement = { hidden: false, value: "", customClass: "" },
}: Props) => {
  const titleValue = title?.value || "";
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const content = (
    <div className="flex flex-col overflow-hidden p-2 md:p-4 gap-2 md:gap-4 items-center">
      {/* IMAGE */}
      {!imageSrc?.hidden && (
        <div className={`relative w-32 md:w-full aspect-[11/12] overflow-hidden ${divelement?.customClass || ""}`}>
          <Image
            src={imageSrcValue}
            alt={titleValue}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px"
            className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`}
            style={getFocusPointStyle(imageMetadata)}
            loading="lazy"
            placeholder="blur"
            blurDataURL={BLUR_PLACEHOLDER}
          />
        </div>
      )}

      {/* Title */}
      {!title?.hidden && (
        <h3 className={`text-16-tamil-700 leading-5 text-1B1B1B line-clamp-1 ${title?.customClass || ""}`}>
          {titleValue}
        </h3>
      )}
    </div>
  );

  if (slug) {
    return (
      <Link href={getSectionUrl(slug)} className="block  transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};
